import React from 'react';

const PostCard = ({ post }) => {
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString() + ' at ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const getOpportunityColor = (type) => {
    const colors = {
      'Answer Question': 'text-green-400',
      'Share Expertise': 'text-cyan-400',
      'Provide Solution': 'text-yellow-400',
      'Join Discussion': 'text-purple-400',
      'Not Relevant': 'text-gray-400'
    };
    return colors[type] || 'text-indigo-400';
  };

  const truncateText = (text, maxLength = 150) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div className="dark-card rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
      <h3 className="text-lg font-semibold mb-3 dark-text leading-tight">{post.title}</h3>
      
      <div className="text-purple-400 font-medium mb-3 text-sm">r/{post.subreddit}</div>
      
      <div className="flex gap-4 mb-4 text-sm dark-text-muted">
        <span className="flex items-center gap-1">👍 {post.upvotes}</span>
        <span className="flex items-center gap-1">💬 {post.comment_count}</span>
        <span className="flex items-center gap-1">📅 {formatDate(post.created_utc)}</span>
      </div>
      
      {post.text && (
        <div className="dark-text-secondary leading-relaxed mb-4 text-sm">
          {truncateText(post.text)}
        </div>
      )}
      
      <div className="bg-gray-700 p-4 rounded-lg mb-4 border-l-4 border-purple-400">
        <div className={`font-semibold mb-2 text-sm ${getOpportunityColor(post.opportunity_type)}`}>
          {post.opportunity_type}
        </div>
        <div className="text-xs dark-text-muted leading-relaxed">
          {post.reasoning || "No reasoning provided"}
        </div>
      </div>
      
      <div className="flex gap-3">
        <a 
          href={post.url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="gradient-bg text-white px-4 py-2 rounded-lg font-medium hover:shadow-lg transition-all duration-200 text-sm"
        >
          View on Reddit
        </a>
        <span className="text-xs dark-text-muted self-center">
          Relevance: {post.relevance_score}/10
        </span>
      </div>
    </div>
  );
};

export default PostCard; 